<template>
  <div class="match-base">
    <el-card>
      <div class="match-base__title">
        匹配规则配置
      </div>
      <div class="match-base__search">
        <div>
          <span>规则名称:</span>
          <el-input size="small" v-model="searchData.ruleName" style="width: 200px;"></el-input>
        </div>
        <div>
          <span>状态:</span>
          <el-select filterable v-model="searchData.valid" placeholder="请选择" size="small">
            
            <el-option label="ALL" :value="null"></el-option>
            <el-option label="有效" :value="1"></el-option>
            <el-option label="无效" :value="0"></el-option>
          </el-select>
        </div>
        <el-button type="primary" size="small" @click="getMatchBase(true)">查询</el-button>
        <el-button type="success" size="small" @click="addConfig">新增</el-button>
      </div>
      <l-table :columns="columns" :data="tableList">
        <template #userType="{ row }">
          <el-tag :type="row.userType === 0 ? 'success' : ''">{{ row.userType === 0 ? '用户' : '主播' }}</el-tag>
        </template>
        <template #matchDaysSwitch="{ row }">
          <p>匹配天数 {{ row.matchDaysSection.replace(',', '-') }} 天</p>
          <p>匹配次数 {{ row.matchTimesSection.replace(',', '-') }} 次</p>
        </template>
        <template #matchUserType="{ row }">
          <p>角色标签组: {{ row.userSign }}</p>
          <p>匹配形式: {{ ['用户','主播','两者'][row.matchUserType] }} </p>
        </template>
        <template #matchRuleUserList="{ row }">
          <el-card v-for="(item, ind) in row.matchRuleUserList" :key="ind" shadow="always" style="margin-top: 12px;">
            <p>被匹配角色{{ ind + 1 }}类型：{{ item.userSign }}</p>
            <p>被匹配角色{{ ind + 1 }}概率：{{ item.matchUserChance }}</p>
          </el-card>
        </template>
        <template #valid="{ row }">
          <el-tag :type="row.valid === 0 ? 'warning' : 'success'">{{ row.valid === 0 ? '下线' : '上线' }}</el-tag>
        </template>
        <template #operation="{ row }">
          <div class="flex-group">
            <el-button type="primary" size="small" @click="editConfig(row)">编辑</el-button>
            <el-button type="info" size="small" @click="copySubmit(row.id)">复制</el-button>
            <el-button type="danger" size="small" @click="deleteSubmit(row.id)">删除</el-button>
            <el-button :type="row.valid === 0 ? 'success' : 'warning'" size="small" @click="changeValidSubmit(row)">
              {{ row.valid === 0 ? '上线' : '下线' }}
            </el-button>
          </div>
        </template>
      </l-table>
      <el-pagination background layout="prev, pager, next" :page-count="pageCount" :current-page.sync="searchData.page"
        @current-change="getMatchBase">
      </el-pagination>
    </el-card>
    <match-base-drawer v-model="dialogData.visible" :config="dialogData.config" :isEdit="dialogData.isEdit"
      @save="saveSubmit" :sign-list="signList" @loadMore="loadMore"></match-base-drawer>
  </div>
</template>

<script>
import { matchRuleReq, matchRuleUpdateReq, matchRuleAddReq, matchRuleCopyReq, matchRuleDeleteReq, signListReq } from '@/api/matchConfigApi'
import LTable from '@/components/L/LTable.vue';
import MatchBaseDrawer from './MatchRuleDrawer.vue'
export default {
  components: {
    LTable,
    MatchBaseDrawer
  },
  data() {
    return {
      searchData: {
        ruleName: '',
        valid: null,
        page: 1
      },
      pageCount:1,
      tableList: [],
      dialogData: {
        visible: false,
        isEdit: false,
        config: {
          ruleName: '',
          matchDaysSwitch: 0,
          matchDaysSection: '',
          matchTimesSwitch: 0,
          matchTimesSection: '',
          userSign: '',
          matchUserType: 0,
          priorityLevel: 0,
          valid: 1,
          matchRuleUserList: [
            {
              matchRuleId: 0,
              userSign: '',
              matchUserChance: 0,
              matchPriorityLevel: 0,
              valid: 1
            }
          ]
        }
      },
      columns: [
        {
          label: '规则编号',
          prop: 'id'
        },
        {
          label: '规则名称',
          prop: 'ruleName'
        },
        {
          label: '规则优先级(越大越优先)',
          prop: 'priorityLevel',
          sortable: true
        },
        {
          label: '行为',
          prop: 'matchDaysSwitch'
        },
        {
          label: '发起方匹配配置',
          prop: 'matchUserType'
        },
        {
          label: '被匹配角色配置',
          prop: 'matchRuleUserList',
          width: '280px'
        },
        // {
        //   label: '备注',
        //   prop: 'id'
        // },
        // {
        //   label: '优先级',
        //   prop: 'id'
        // },
        {
          label: '状态',
          prop: 'valid'
        },
        {
          label: '操作',
          prop: 'operation',
          width: '180px'
        },
      ],
      signList: [],
      page: 1
    }
  },
  methods: {
    loadMore(){
      clearTimeout(this.timer)
      this.timer = setTimeout(() => {
        this.page++
        this.getSignList(this.page)
      }, 1000)
    },
    async getSignList() {
      const res = await signListReq(this.page);
      if (res.code === 0 || res.status === 0) {
        // this.$message.success('操作成功')
        this.$set(this, 'signList', this.signList.concat(res.data.list))
      } else {
        this.$message.warning(res.msg || res.message)
      }
    },
    // 获取匹配基础功能配置
    async getMatchBase(bool) {
      if (bool === true) this.searchData.page = 1
      const res = await matchRuleReq(this.searchData)
      if (res.code === 0) {
        this.tableList = res.data.matchRuleConfigBOList
        this.$message({ type: 'success', message: "查询成功" })
        this.pageCount = res.data.totalPages
      } else {
        this.$message.error(res.msg)
        this.tableList = []
      }
    },
    editConfig(row) {
      this.dialogData.isEdit = true;
      this.dialogData.config = JSON.parse(JSON.stringify(row));
      this.dialogData.visible = true;
    },
    addConfig() {
      this.dialogData.isEdit = false;
      this.dialogData.config = this.$options.data().dialogData.config;
      this.dialogData.visible = true;
    },
    deleteSubmit(id) {
      this.$confirm('是否删除该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchRuleDeleteReq({ id })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('delete success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    copySubmit(id) {
      this.$confirm('是否复制该配置?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchRuleCopyReq({ id })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('copy success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    changeValidSubmit(row) {
      let text = row.valid === 0 ? '是否进行上线操作' : "是否进行下线操作"
      this.$confirm(text, '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(async () => {
        const res = await matchRuleUpdateReq({
          ...row,
          valid: Math.abs(row.valid - 1),
        })
        if (res.code === 0 || res.status === 0) {
          this.$message.success('change success')
          this.getMatchBase()
        } else {
          this.$message.warning(res.msg || res.message)
        }
      }).catch(() => {
      });
    },
    async saveSubmit(obj) {
      // 编辑
      let res = null;
      if (this.dialogData.isEdit) {
        res = await matchRuleUpdateReq(obj)
      } else {
        res = await matchRuleAddReq(obj)
      }
      if (res.code === 0 || res.status === 0) {
        this.$message.success('操作成功')
        this.dialogData.visible = false;
        this.getMatchBase()
      } else {
        this.$message.warning(res.msg || res.message)
      }
    }
  },
  mounted() {
    this.getMatchBase()
    this.getSignList()
  },
  activated() {
  }
}
</script>

<style scoped lang="scss">
.match-base {
  &__main {
    height: 100px;
  }

  &__title {
    font-size: 22px;
    font-weight: 600;
    margin-bottom: 20px;
  }

  &__search {
    display: flex;
    gap: 14px;
    flex-wrap: wrap;

    .el-select,
    .el-input {
      margin-left: 12px;
    }
  }
}

.flex-group {
  display: flex;
  align-items: center;
  justify-content: space-around;
  flex-wrap: wrap;
  min-height: 80px;

  .el-button {
    margin: 0;
  }
}
</style>